import {
  Autocomplete,
  Box,
  Button,
  createFilterOptions,
  Dialog,
  DialogTitle,
  TextField,
} from '@mui/material'
import {ParentContext} from 'app/hooks/ApiParentContext'
import {useOnLoadGet} from 'app/hooks/common/useOnLoadGet'
import {useAddUserToSubscriptionV2} from 'app/hooks/subscription/useAddUserToSubscriptionV2'
import {CSubscription, CTenant} from 'app/modules/discovery/core'
import {useState} from 'react'

export function DialogAddUserToSubscription(props: {
  subscriptionId?: string
  tenantId?: string
  closeFunc: () => void
}) {
  const {subscriptionId, tenantId, closeFunc} = props
  const users = useOnLoadGet<any>(`std/user`)

  const userPicks =
    users?.data &&
    Array.isArray(users.data) &&
    users?.data?.filter(
      (x: any) => !x.subscriptions?.map((y: any) => y.id).includes(subscriptionId)
    )
  const [selections, setSelections] = useState<string[]>([])
  const parentContext = new ParentContext({
    parentClass: CTenant,
    childClass: CSubscription,
    prop: 'subscriptions',
    parentId: tenantId ?? '',
  })

  const addUserToSubscriptionV2 = useAddUserToSubscriptionV2()
  const userOptions =
    userPicks
      ?.filter((x: any) => x.id && !selections.includes(x.id))
      .map((x: any) => ({label: `${x.last_name}, ${x.first_name} (${x.email})`, id: x.id})) ?? []

  function addUser(id: string) {
    if (!selections.includes(id)) {
      setSelections([...selections, id])
    }
  }

  function removeUser(id: string) {
    if (selections.includes(id)) {
      setSelections(selections.filter((x) => x !== id))
    }
  }

  function cancel() {
    setSelections([])
    closeFunc()
  }

  function confirm() {
    for (const id of selections) {
      //addSubscriptionToUser.mutateAsync({parentId: id, childId: subscriptionId ?? ''})
      addUserToSubscriptionV2.mutateAsync({
        user_id: id,
        subscription_id: subscriptionId ?? '',
        is_tenant_admin: true,
      })
    }
    setSelections([])
    closeFunc()
  }

  return (
    <Dialog open={!!(subscriptionId && tenantId)}>
      <DialogTitle sx={{backgroundColor: 'black', color: 'white'}}>Add Users</DialogTitle>
      <Box sx={{margin: '20px', minWidth: '500px', fontSize: '16px'}}>
        <Box sx={{marginBottom: '12px', minHeight: '150px'}}>
          <Autocomplete
            disablePortal
            id='user-selector'
            options={userOptions}
            getOptionLabel={(x) => x.label}
            renderInput={(params) => <TextField {...params} label='User'></TextField>}
            onChange={(event: any, val: {label: string; id: string | undefined} | null) => {
              val?.id ? addUser(val.id) : null
            }}
            filterOptions={createFilterOptions({limit: 4})}
          ></Autocomplete>
        </Box>
        <Box sx={{display: 'flex'}}>
          <Box sx={{flex: '1 1 auto'}}></Box>
          <Box sx={{flex: '0 0 auto', display: 'flex'}}>
            <Button sx={{fontSize: '14px'}} onClick={cancel}>
              Cancel
            </Button>
            <Button sx={{fontSize: '14px'}} onClick={confirm}>
              OK
            </Button>
          </Box>
        </Box>
      </Box>
    </Dialog>
  )
}
